import InfoIcon from '../../../../../ui/svg/common/info';
import React, { useState } from 'react';
import ReferRecurringCreditPopup from './recurring-popup';
import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { checkIsSubscription } from '../../domain/shopping-cart-provider';


const ReferCreditRecurring = () => {
    const dispatch = useAppDispatch();

    const [ recurringPopupVisible, setRecurringPopupVisible ] = useState(false);
    const isReferRecurringChecked = useAppSelector(store => store.root.isReferRecurringChecked);

    const cartData = useAppSelector(store => store.root.cartData);
    const isSubscription = checkIsSubscription(cartData);

    const showRecurringPopup = () => {
        setRecurringPopupVisible(true);
    };

    const hideRecurringPopup = () => {
        setRecurringPopupVisible(false);
    };

    const onCreditRecurringCheckboxChange = () => {
        dispatch(
            rootActions.main({
                isReferRecurringChecked: !isReferRecurringChecked
            })
        );
    };

    return (
        <>
            {
                isSubscription && cartData.isReferFriendEnabled && cartData.availableCredit > 0 &&
                <label className="flex items-start mt-2">
                    <input
                        aria-label="Redeem My Rewards on Recurring Payments"
                        type="checkbox"
                        checked={ isReferRecurringChecked }
                        onChange={ onCreditRecurringCheckboxChange }
                    />

                    <span className="mx-2 cursor-pointer" style={{
                        marginTop: '-4px',
                    }}>Redeem My Rewards on Recurring Payments</span>

                    <button
                        title="Learn More about Redeem My Rewards on Recurring Payments"
                        type="button"
                        onClick={ showRecurringPopup }
                        className="flex items-center">
                        <InfoIcon width="15px" color="#777" />
                    </button>
                </label>
            }

            { recurringPopupVisible && <ReferRecurringCreditPopup close={ hideRecurringPopup } isShoppingCart={ true } /> }
        </>
    )
};

export default ReferCreditRecurring;